/**
 * @ 引用素材的公共逻辑
 *
 * 谁在用：首页对话框、AI 图片的「补充描述」、AI 视频的「创作描述 / 复刻描述」。
 *
 * 为什么必须抽成一份：编辑器里的 chip 显示成 `@素材名`，**提交给模型前必须变成
 * `[参考图N]`** —— N 是该素材在「实际传给模型的参考图数组」里的序号（从 1 开始）。
 * 名称规则与编号规则只要有一处不一致，就会出现「chip 明明叫 A，替换时却去找 B」，
 * 结果是提示词里的编号指向了别的图 —— 模型照错图生成，而且不报错、静默出错。
 */

/**
 * 素材显示名：优先 name，否则取文件名去扩展名，最后兜底「素材N」。
 *
 * 编辑器里 chip 显示的名字、以及替换 @ 时匹配的名字，都必须走这一个函数。
 */
export function mentionName(item, idx) {
  if (!item) return '素材' + (idx + 1)
  if (item.name) return item.name
  const p = String(item.file_path || item.path || '')
  const slash = Math.max(p.lastIndexOf('/'), p.lastIndexOf('\\'))
  const dot = p.lastIndexOf('.')
  const base = dot > slash ? p.slice(slash + 1, dot) : p.slice(slash + 1)
  return base || ('素材' + (idx + 1))
}

/**
 * 把描述里的 `@素材名` 替换成对应记号（默认 `[参考图N]`）。
 *
 * @param {string}   text    编辑器里的纯文本（chip 已展开成 @名称）
 * @param {Array}    sources 与**提交给模型的参考图数组同序同源**的素材列表
 *                           （顺序不一致 → 编号指向的图就错了）
 * @param {Function} format  可选：`(index) => 记号`。图片侧用默认的 `[参考图N]`；
 *                           **视频侧要传 `<图片N>`** —— 那是 Seedance 官方的素材引用语法，
 *                           自造的 `[参考图N]` 模型不认，描述里的指代会失效。
 *
 * 名称长的优先替换：否则 @杯子 会先命中 @杯子主图 的前缀，替换出半截编号。
 */
export function resolveMentions(text, sources, format) {
  let out = String(text || '')
  const list = sources || []
  const mark = typeof format === 'function' ? format : (i => '[参考图' + i + ']')
  const items = list.map((s, i) => ({ name: mentionName(s, i), index: i + 1 }))
  items.sort((a, b) => b.name.length - a.name.length)
  for (const it of items) {
    if (!it.name) continue
    const token = '@' + it.name
    if (out.indexOf(token) < 0) continue
    out = out.split(token).join(mark(it.index))
  }
  return out
}
